import mime from 'mime'

const _FALLBACK_FILE_NAME = 'download'

export const promptFileDownload = async (fileContent: Blob, fileName?: string) => {
  try {
    const url = window.URL.createObjectURL(fileContent)
    const a = document.createElement('a')

    a.href = url
    a.download = fileName ?? _FALLBACK_FILE_NAME
    document.body.appendChild(a)
    a.click()

    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  } catch (e) {
    console.error(e)
  }
}

const SUPPORTED_MEDIA_TYPES = new Set([
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'audio/mp4',
  'audio/webm',
  'audio/flac',
  'audio/ogg',
  'audio/mpeg',
  'audio/x-m4a',
  'audio/aac',
  'audio/wav',
  'audio/x-wav',
])

export const isMediaFile = (file: File) => {
  if (isMediaFileType(file.type)) {
    return true
  }
  const type = mime.getType(file.name)
  return type ? isMediaFileType(type) : false
}

export const isMediaFileType = (type: File['type']) => SUPPORTED_MEDIA_TYPES.has(type)
